import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../store/auth";
import { validateTokenOnLaunch, refreshToken } from "@/apis/loginapis";
import { getAdminById } from "@/apis/admin";
import { jwtDecode } from "jwt-decode";

import settlements from "./settlements";
import transaction from "./transaction";
import PosList from "@/pages/Pos/PosList.vue";

import Cookies from "js-cookie";
import Home from "@/pages/Overview/Home.vue";
import Admins from "@/pages/Admin/AdminList.vue";
import Users from "@/pages/Customer/CustomersList.vue";
import Bookings from "@/pages/Booking/BookingList.vue";
import Operators from "@/pages/Operator/OperatorsList.vue";
import Buses from "@/pages/Bus/BusesList.vue";

import CoupanList from "@/pages/Coupon/CouponList.vue";
import CityList from "@/pages/City/CityList.vue";
import MyProfile from "@/pages/Profile/MyProfile.vue";
import Login from "@/pages/Login/Login.vue";
import AddUser from "@/pages/Customer/Customer.vue";
import AddBus from "@/pages/Bus/Bus.vue";
import AddCoupan from "@/pages/Coupon/Coupon.vue";
import AddOperator from "@/pages/Operator/Operator.vue";
import BusDetails from "@/pages/Overview/BusDetails.vue";
import City from "@/pages/City/City.vue";
import AddAdmin from "@/pages/Admin/Admin.vue";
import AddFaq from "@/pages/Faq/AddFaq.vue";
import FaqList from "@/pages/Faq/FaqList.vue";
import ViewBookings from "@/pages/Booking/Bookings.vue";
import ViewTicket from "@/pages/Booking/ViewTicket.vue";
import Refferals from "@/pages/Refferal/RefferalsList.vue";
import viewRefferal from "@/pages/Refferal/Refferal.vue";
import Report from "@/pages/Report/Report.vue";

const routes = [
  ...settlements,
  ...transaction,
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports",
    name: "Report",
    component: Report,
    meta: { requiresAuth: true },
  },
  {
    path: "/pos",
    name: "Pos",
    component: PosList,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/add_faq",
    name: "Add Faq",
    component: AddFaq,
    meta: { requiresAuth: true },
  },
  {
    path: "/faqs",
    name: "Faq List",
    component: FaqList,
    meta: { requiresAuth: true },
  },
  {
    path: "/add_city",
    name: "Add City",
    component: City,
    meta: { requiresAuth: true },
  },
  {
    path: "/bus_details",
    name: "Bus Details",
    component: BusDetails,
    meta: { requiresAuth: true },
  },
  {
    path: "/user/:phone",
    name: "New User",
    component: AddUser,
    meta: { requiresAuth: true },
  },
  {
    path: "/ticket_details/:id",
    name: "Ticket Details",
    component: ViewBookings,
    meta: { requiresAuth: true },
  },
  {
    path: "/view_ticket/:id",
    name: "View Ticket",
    component: ViewTicket,
    meta: { requiresAuth: true },
  },
  {
    path: "/referrals",
    name: "Refferals Page",
    component: Refferals,
    meta: { requiresAuth: true },
  },
  {
    path: "/viewRefferal/:phone",
    name: "View Refferal",
    component: viewRefferal,
    meta: { requiresAuth: true },
  },
  {
    path: "/add_operator/:phone_number",
    name: "New Operator",
    component: AddOperator,
    meta: { requiresAuth: true },
  },
  {
    path: "/add_coupan",
    name: "New Coupan",
    component: AddCoupan,
    meta: { requiresAuth: true },
  },
  {
    path: "/add_bus",
    name: "New Bus",
    component: AddBus,
    meta: { requiresAuth: true },
  },
  {
    path: "/add_admin",
    name: "New Admin",
    component: AddAdmin,
    meta: { requiresAuth: true },
  },
  {
    path: "/admins",
    name: "Admins",
    component: Admins,
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { requiresAuth: true },
  },
  {
    path: "/bookings",
    name: "Bookings",
    component: Bookings,
    meta: { requiresAuth: true },
  },
  {
    path: "/operators",
    name: "Operators",
    component: Operators,
    meta: { requiresAuth: true },
  },
  {
    path: "/buses",
    name: "Bus",
    component: Buses,
    meta: { requiresAuth: true },
  },

  {
    path: "/coupon_and_offers",
    name: "Coupon & Offers",
    component: CoupanList,
    meta: { requiresAuth: true },
  },
  {
    path: "/city",
    name: "City",
    component: CityList,
    meta: { requiresAuth: true },
  },
  {
    path: "/my_profile",
    name: "My Profile",
    component: MyProfile,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

let isInitialized = false;

router.beforeEach(async (to, from, next) => {
  const accessToken = Cookies.get("accessToken");
  const authStore = useAuthStore();

  // Skip auth for routes that don't require it
  if (to.meta.requiresAuth === false) {
    return next();
  }

  if (!accessToken && to.path !== "/login") {
    return next("/login");
  }

  if (accessToken && !isInitialized) {
    let isValid = await validateTokenOnLaunch();

    if (!isValid.success) {
      const refreshResponse = await refreshToken();

      if (!refreshResponse.status) {
        return next("/login");
      }

      Cookies.set("accessToken", refreshResponse.accessToken, {
        expires: 7,
        secure: true,
      });
      Cookies.set("refreshToken", refreshResponse.refreshToken, {
        expires: 30,
        secure: true,
      });
    }

    const decodedData = jwtDecode(Cookies.get("accessToken"));
    const response1 = await getAdminById(decodedData.userId);

    localStorage.setItem("ldata", JSON.stringify(response1.data[0]));
    authStore.setLdata();

    isInitialized = true;
  }

  next();
});

export default router;
